// importar tudo o que quiseres e exportar num array ou objeto
import img1 from "./Pessoas_2030.svg";
import img2 from "./PRR.svg";
import img3 from "./Portugal2030.svg";
import img4 from "./Republica_Portuguesa.svg";

export const footerImages = [img1, img2, img3, img4];

// ou com nomes:
export const namedImages = {
  first: img1,
  second: img2,
  third: img3,
  fourth: img4,
};
